import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大核心分类，覆盖日本文化、娱乐、生活、旅游等领域，精准分级为您导航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors duration-300 ${
                    cat.color === 'primary'
                      ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                      : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                  }`}
                >
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-1.5 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {cat.description}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-primary-600 font-medium">
                    <span>{cat.articleCount} 篇内容</span>
                    <div className="w-3 h-3 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}